import { makeStyles, TextField, Theme } from "@material-ui/core";
import React from "react";
import { useDebouncedCallback } from "use-debounce";

const DEFAULT_DEBAOUNCE_MS = 750;

const useStyles = makeStyles<Theme, { variant: string }>((theme) => ({
  cssOutlinedInput: ({ variant }) => ({
    marginTop: 3,
    $notchedOutline: {
      borderColor: `${
        variant === "contrastText"
          ? theme.palette.secondary.contrastText
          : theme.palette.secondary.dark
      } !important`,
    },
  }),
  cssLabel: ({ variant }) => ({
    color:
      variant === "contrastText"
        ? theme.palette.secondary.contrastText
        : theme.palette.secondary.dark,
  }),
  notchedOutline: ({ variant }) => ({
    borderWidth: "2px",
    borderColor: `${
      variant === "contrastText"
        ? theme.palette.secondary.contrastText
        : theme.palette.secondary.dark
    } !important`,
    margin: 3,
  }),
  input: ({ variant }) => ({
    color:
      variant === "contrastText"
        ? theme.palette.secondary.contrastText
        : theme.palette.secondary.dark,
    "&::placeholder": {
      textOverflow: "ellipsis !important",
      color:
        variant === "contrastText"
          ? theme.palette.secondary.contrastText
          : theme.palette.secondary.dark,
    },
  }),
}));

type FilterSearchProps = {
  title: string;
  value: string;
  onChange: (value: string | undefined) => void;
  debounceMs?: number;
  dataTest?: string;
  variant?: "contrastText" | "dark";
};

export const FilterSearch: React.FC<FilterSearchProps> = ({
  title,
  value,
  onChange,
  debounceMs = DEFAULT_DEBAOUNCE_MS,
  dataTest,
  variant = "contrastText",
}) => {
  const _onChange = useDebouncedCallback(onChange, debounceMs);

  const classes = useStyles({ variant });

  return (
    <TextField
      variant="outlined"
      size="small"
      placeholder={title}
      onChange={(event) => _onChange.callback(event.target.value || undefined)}
      defaultValue={value}
      data-test={dataTest}
      InputProps={{
        classes: {
          input: classes.input,
          root: classes.cssOutlinedInput,
          notchedOutline: classes.notchedOutline,
        },
      }}
      InputLabelProps={{
        classes: {
          root: classes.cssLabel,
        },
      }}
    ></TextField>
  );
};
